document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.motion-fade-up');

  if (!('IntersectionObserver' in window) || !items.length) {
    items.forEach(item => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  items.forEach(item => observer.observe(item));
});